module.exports = __webpack_public_path__ + "static/img/home-supplier.b3639caf.png";